<template lang="pug">
div
  .top(ref="top")
  .alert.alert-danger(v-if="this.validationMessages['global']") {{ this.validationMessages['global'] }}
  .minishop(v-if="orderCompleted")
    .alert.alert-success.mt-3 Vielen Dank! Ihre Bestellung ist bei uns eingegangen. Sie erhalten in Kürze eine Bestätigung per E-Mail.
  .minishop(v-if="nothingLeft && !orderCompleted")
    .alert.alert-success Eine weitere Bestellung ist nicht möglich.
  .minishop(v-if="shop")
    .alert.alert-danger(v-if="this.callbackMessage") {{ this.callbackMessage }}
    template(v-if="success")
      .alert.alert-info Bestellung wird übermittelt.
    template(v-if="!success")
      .products.mb-4
        template(v-for="(specialOffer, index) in shop.specialOffersList")
          special-offer(:specialOffer="specialOffer" :productQuantities="quantitiesMap" :remainingProductQuantities="remainingQuantitiesMap" :noCartButtons="noCartButtons" @update-quantities="updateQuantities" )
        .error.invalid-feedback.d-block(v-if="vm('price')") {{ vm('price') }}
      .addresses
        address-form(name="Rechnungsadresse" addressType="ADDRESS_TYPE_INVOICE" :address="invoiceAddress" :validationMessages="validationMessages" :displayValidation="displayValidation" :austriaEnabled="austriaEnabled")
        .form-group.row.mt-2.mb-2(v-if="austriaEnabled")
          label.col-sm-2.col-form-label(for="i-gewerbeschein") Gewerbeschein
          .col-sm-8
            input#i-gewerbeschein.form-control.form-control-sm(v-model="gewerbescheinNumber" :class="[{ 'is-invalid': vm('gewerbescheinNumber') }, 'form-control']")
            .error.invalid-feedback(v-if="vm('gewerbescheinNumber')") {{ vm('gewerbescheinNumber') }}
        .form-group.row.mt-2.mb-2
          .col-sm-10.offset-sm-2
            .form-check
              input.form-check-input(type="checkbox" id="differentDelivery" v-model="differentDeliveryAddress")
              label.form-check-label(for="differentDelivery") Abweichende Lieferadresse
        address-form(v-if="differentDeliveryAddress" name="Lieferadresse" addressType="ADDRESS_TYPE_DELIVERY" :address="deliveryAddress" :validationMessages="validationMessages" :displayValidation="displayValidation" :austriaEnabled="austriaEnabled")
      .email.form-group.row
        label.col-sm-2.col-form-label(for="email") E-Mail
        .col-sm-8
          input.form-control.form-control-sm(v-model="email" :class="[{ 'is-invalid': vm('email') }, 'form-control']")
          .error.invalid-feedback(v-if="vm('email')") {{ vm('email') }}
      template
        h2 Preis
        div.totals.mb-3
          .description(style="text-align:left;width:150px;display:inline-block;")
            div(v-if="totalWithoutVat !== null") Netto
            div(v-if="vatValue !== null") {{ vatPercentage }} MwSt.
            div(v-if="totalWithVat !== null")
              strong Brutto
          .prices(style="text-align:right;width:100px;display:inline-block;")
            div(v-if="totalWithoutVat !== null") {{ totalWithoutVat }}
            div(v-if="vatValue !== null") {{ vatValue }}
            div(v-if="totalWithVat !== null")
              strong {{ totalWithVat }}
          .error.invalid-feedback.d-block(v-if="vm('price')") {{ vm('price') }}
      h2 Zustimmungen
      .form-group.row
        .col-sm-12
          | Bestandteil dieses Angebots ist, dass wir Ihnen kostenlos und unverbindlich weitere Angebote und Informationsmaterial zukommen lassen und Ihre PLZ zu Auswertungszwecken verwendet wird.
      .form-group.row
        .col-sm-1
          input.form-control.form-control-sm(type="checkbox" required v-model="consentA" :class="[{ 'error': vm('consentA') }, 'form-control']")
        .col-sm-11(:class="[{ 'text-danger': vm('consentA') }]" v-on:click.prevent="consentA = !consentA" style="cursor: pointer")
          | Ich habe zur Kenntnis genommen, dass mir MALU WILZ kostenlos und unverbindlich weitere Angebote und Informationsmaterial zukommen lassen wird.
      .form-group.row
        .col-sm-1
          input.form-control.form-control-sm(type="checkbox" required v-model="consentB" :class="[{ 'is-invalid': vm('consentB') }, 'form-control']")
        .col-sm-11(:class="[{ 'text-danger': vm('consentB') }]" v-on:click.prevent="consentB = !consentB" style="cursor: pointer")
          | Ich habe zur Kenntnis genommen, dass meine PLZ zu Auswertungszwecken verwendet wird und ich u.U. von einem Außendienstmitarbeiter kontaktiert bzw. besucht werde.
      .form-group.row
        .col-sm-12
          | Es gelten unsere&nbsp;
          a(:href="agbUrl" target="_blank" rel="noopener") Allgemeinen Geschäftsbedingungen
          | .
      .form-group.row
        .col-sm-12
          | Weitere Hinweise zum Datenschutz finden Sie unter&nbsp;
          a(:href="datenschutzUrl" target="_blank" rel="noopener") {{ datenschutzUrl }}
      .form-group.row
        .col-sm-12
          | Wichtiger Hinweis zur Rückgabe unserer Testpakete: Unsere Testpakete sind speziell für die persönliche Erprobung unserer Produkte konzipiert. Daher ist eine Rückgabe der Testpakete ausgeschlossen, wenn Ihnen die Produkte nicht zusagen. Selbstverständlich nehmen wir jedoch beschädigte oder fehlerhafte Ware zurück und sorgen für Ersatz. Sollten Sie eine beschädigte Lieferung erhalten, kontaktieren Sie bitte unseren Kundenservice unter partner@malu-wilz-beaute.com innerhalb von 7 Tagen nach Erhalt der Ware.
      button.text-white.mt-4.btn.btn-primary(v-if="!paypalStepActive" v-on:click.prevent="setPaypalActive" style="width:100%; margin-bottom:250px") Weiter
      div.ppc(v-show="paypalStepActive && Object.keys(validationMessages).length == 0")
        #paypal-button-container(v-show="!isTestOrder")
        button.text-white.mt-4.btn.btn-warning(v-if="isTestOrder" :disabled="invoiceLoading" v-on:click.prevent="submitTestOrder" style="width:100%") Testbestellung absenden (ohne Zahlung)
        // Kauf auf Rechnung temporarily disabled
        // button.text-white.mt-4.mb-4.btn.btn-secondary(:disabled="invoiceLoading" v-on:click.prevent="onInvoice" style="width: 100%; border-radius: 4px; line-height: 24px; font-size: 20px; height: 55px;") Verbindlich auf Rechnung bestellen
    template(v-else)
      template(v-show="paypalStepActive && Object.keys(validationMessages).length == 0")
        #paypal-button-container.pp(v-show="false")
</template>

<script>
import { mapActions } from 'vuex'
import { AddressType } from '@/proto/common/common_pb'
import AddressForm from '@/components/AddressForm'
import SpecialOffer from '@/components/SpecialOffer'
import { cmsPage } from '@/cmsPages'

export default {
  name: 'MiniShop',
  components: { AddressForm, SpecialOffer },
  data: () => ({
    shop: null,
    remainingQuantitiesMap: {},
    quantitiesMap: {},
    invoiceAddress: {
      addressType: AddressType.ADDRESS_TYPE_INVOICE,
      name1: '',
      name2: '',
      street: '',
      zip: '',
      city: '',
      country: 'DE'
    },
    deliveryAddress: {
      addressType: AddressType.ADDRESS_TYPE_DELIVERY,
      name1: '',
      name2: '',
      street: '',
      zip: '',
      city: '',
      country: 'DE'
    },
    email: '',
    gewerbescheinNumber: '',
    oid: null,
    poid: null,
    validationMessages: {},
    createOrderError: null,
    captureOrderMessage: null,
    captureOrderError: null,
    captured: false,
    success: false,
    orderCompleted: false,
    plannedValidation: null,
    consentA: false,
    consentB: false,
    consentRoadshow: false,
    roadshowCity: null,
    consentWebinar: false,
    paypalStepActive: false,
    differentDeliveryAddress: false,
    displayValidation: false,
    callbackMessage: null,
    totalWithVat: null,
    totalWithoutVat: null,
    vatPercentage: null,
    vatValue: null,
    noCartButtons: false,
    invoiceLoading: false
  }),
  computed: {
    austriaEnabled () {
      return !!(this.shop && this.shop.austriaEnabled)
    },
    isTestOrder () {
      // Hardcoded test address (keep in sync with the backend testOrderEmailDefault).
      // Do NOT read this from process.env: on prod the value is an envsubst
      // placeholder that the minifier folds, dropping any `|| fallback`.
      return (this.email || '').trim().toLowerCase() === 'ws@funktionslust.digital'
    },
    nothingLeft () {
      if (Object.keys(this.remainingQuantitiesMap).length === 0) {
        return false
      }
      for (let key in this.remainingQuantitiesMap) {
        if (this.remainingQuantitiesMap[key] > 0) {
          return false
        }
      }
      return true
    },
    datenschutzUrl () {
      return cmsPage('datenschutz')
    },
    agbUrl () {
      return cmsPage('agb')
    }
  },
  watch: {
    email: {
      handler () {
        clearTimeout(this.plannedValidation)
        this.plannedValidation = setTimeout(this.validateShop, 500)
      },
      deep: true
    },
    quantitiesMap: {
      handler () {
        clearTimeout(this.plannedValidation)
        this.plannedValidation = setTimeout(this.validateShop, 500)
      },
      deep: true
    },
    invoiceAddress: {
      handler () {
        clearTimeout(this.plannedValidation)
        this.plannedValidation = setTimeout(this.validateShop, 500)
      },
      deep: true
    },
    deliveryAddress: {
      handler () {
        clearTimeout(this.plannedValidation)
        this.plannedValidation = setTimeout(this.validateShop, 500)
      },
      deep: true
    },
    consentA: {
      handler () {
        clearTimeout(this.plannedValidation)
        this.plannedValidation = setTimeout(this.validateShop, 500)
      }
    },
    consentB: {
      handler () {
        clearTimeout(this.plannedValidation)
        this.plannedValidation = setTimeout(this.validateShop, 500)
      }
    }
  },
  async mounted () {
    localStorage.setItem('b2b', true)
    if (this.$miniShopName) {
      await this.loadMiniShop()
      await this.loadPayPal()
      await this.validateShop()
    } else {
      console.error('no mini shop name available')
    }
  },
  methods: {
    async resetData () {
      this.shop = null
      this.remainingQuantitiesMap = {}
      this.quantitiesMap = {}
      this.invoiceAddress = {
        addressType: AddressType.ADDRESS_TYPE_INVOICE,
        name1: '',
        name2: '',
        street: '',
        zip: '',
        city: '',
        country: 'DE'
      }
      this.deliveryAddress = {
        addressType: AddressType.ADDRESS_TYPE_DELIVERY,
        name1: '',
        name2: '',
        street: '',
        zip: '',
        city: '',
        country: 'DE'
      }
      this.capturedEmail = ''
      this.email = ''
      this.gewerbescheinNumber = ''
      this.oid = null
      this.poid = null
      this.validationMessages = {}
      this.createOrderError = null
      this.captureOrderMessage = null
      this.captureOrderError = null
      this.plannedValidation = null
      this.consentA = false
      this.consentB = false
      this.consentRoadshow = false
      this.roadshowCity = null
      this.consentWebinar = false
      this.paypalStepActive = false
      this.displayValidation = false
      this.callbackMessage = null
      this.totalWithVat = null
      this.totalWithoutVat = null
      this.vatPercentage = null
      this.vatValue = null
      this.noCartButtons = false
      await this.loadMiniShop()
      await this.loadPayPal()
      await this.validateShop()
    },
    async setPaypalActive () {
      // Client-side validation for required fields
      this.validationMessages = {}

      // Validate invoice address
      if (!this.invoiceAddress.name2 || this.invoiceAddress.name2.trim() === '') {
        this.validationMessages['ADDRESS_TYPE_INVOICE.name2'] = 'Name ist erforderlich'
      }
      if (!this.invoiceAddress.street || this.invoiceAddress.street.trim() === '') {
        this.validationMessages['ADDRESS_TYPE_INVOICE.street'] = 'Straße ist erforderlich'
      }
      if (!this.invoiceAddress.zip || this.invoiceAddress.zip.trim() === '') {
        this.validationMessages['ADDRESS_TYPE_INVOICE.zip'] = 'PLZ ist erforderlich'
      }
      if (!this.invoiceAddress.city || this.invoiceAddress.city.trim() === '') {
        this.validationMessages['ADDRESS_TYPE_INVOICE.city'] = 'Stadt ist erforderlich'
      }

      // Validate delivery address only if different
      if (this.differentDeliveryAddress) {
        if (!this.deliveryAddress.name2 || this.deliveryAddress.name2.trim() === '') {
          this.validationMessages['ADDRESS_TYPE_DELIVERY.name2'] = 'Name ist erforderlich'
        }
        if (!this.deliveryAddress.street || this.deliveryAddress.street.trim() === '') {
          this.validationMessages['ADDRESS_TYPE_DELIVERY.street'] = 'Straße ist erforderlich'
        }
        if (!this.deliveryAddress.zip || this.deliveryAddress.zip.trim() === '') {
          this.validationMessages['ADDRESS_TYPE_DELIVERY.zip'] = 'PLZ ist erforderlich'
        }
        if (!this.deliveryAddress.city || this.deliveryAddress.city.trim() === '') {
          this.validationMessages['ADDRESS_TYPE_DELIVERY.city'] = 'Stadt ist erforderlich'
        }
      }

      // Validate email
      if (!this.email || this.email.trim() === '') {
        this.validationMessages['email'] = 'E-Mail ist erforderlich'
      } else if (!this.email.includes('@')) {
        this.validationMessages['email'] = 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
      }

      // If client-side validation passes, do server-side validation
      if (Object.keys(this.validationMessages).length === 0) {
        await this.validateShop()
      }

      this.displayValidation = true
      if (Object.keys(this.validationMessages).length === 0) {
        this.paypalStepActive = true
      } else {
        this.$nextTick(() => {
          const firstError = document.querySelector('.is-invalid, .invalid-feedback.d-block')
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }
    },
    updateQuantities (newQuantities) {
      clearTimeout(this.plannedValidation)
      this.plannedValidation = setTimeout(this.validateShop, 500)
      this.quantitiesMap = newQuantities
    },
    vm (slug) {
      if (!this.displayValidation) {
        return false
      }
      return this.validationMessages[slug]
    },
    ...mapActions('miniShop', [
      'getMiniShop',
      'createMiniShopOrder',
      'captureMiniShopOrder',
      'validateMiniShopOrder',
      'error'
    ]),
    getUserInput (data) {
      let urlParams = new URLSearchParams(window.location.search)
      data.shopName = this.$miniShopName
      data.vid = this.setAndGetCached('vid', null)
      data.ref = this.setAndGetCached('ref', urlParams.get('r'))
      data.fbclid = this.setAndGetCached('fbclid', urlParams.get('fbclid'))
      data.gclid = this.setAndGetCached('gclid', urlParams.get('gclid'))
      data.qr = this.setAndGetCached('qr', urlParams.get('q'))
      data.ua = navigator.userAgent
      return data
    },
    async validateShop () {
      this.plannedValidation = null
      var email = this.email
      if (!email && this.capturedEmail) {
        email = this.capturedEmail
      }
      const filteredQuantitiesMap = Object.fromEntries(
        Object.entries(this.quantitiesMap).filter(([key, value]) => value > 0)
      )
      const effectiveDeliveryAddress = this.differentDeliveryAddress
        ? this.deliveryAddress
        : { ...this.invoiceAddress, addressType: AddressType.ADDRESS_TYPE_DELIVERY }
      if (await this.validateMiniShopOrder(this.getUserInput({
        quantitiesMap: filteredQuantitiesMap,
        invoiceAddress: this.invoiceAddress,
        deliveryAddress: effectiveDeliveryAddress,
        email: email,
        gewerbescheinNumber: this.gewerbescheinForSubmit()
      }))) {
        this.setRemainingQuantitiesMap(this.$store.state.miniShop.latestRequests.validateMiniShopOrder.response.remainingQuantitiesMap)
        this.setValidationMessages(this.$store.state.miniShop.latestRequests.validateMiniShopOrder.response.messagesMap)
        this.setTotals(this.$store.state.miniShop.latestRequests.validateMiniShopOrder.response)
        if (!this.consentA) {
          this.validationMessages['consentA'] = 'Ihre Zustimmung ist erforderlich'
        }
        if (!this.consentB) {
          this.validationMessages['consentB'] = 'Ihre Zustimmung ist erforderlich'
        }
        let totalQty = 0
        for (let key in this.quantitiesMap) {
          totalQty = totalQty + this.quantitiesMap[key]
        }
        if (totalQty === 0) {
          this.validationMessages['price'] = 'Ein Angebot muss ausgewählt werden, der Bestellwert muss über 0.00 € liegen'
        }
      }
    },
    setTotals (totals) {
      this.totalWithVat = totals.totalWithVat
      this.totalWithoutVat = totals.totalWithoutVat
      this.vatPercentage = totals.vatPercentage
      this.vatValue = totals.vatValue
    },
    // The Gewerbeschein field is shown for Austria-enabled shops (both DE and AT
    // selections); only submit it for those shops.
    gewerbescheinForSubmit () {
      return this.austriaEnabled ? this.gewerbescheinNumber : ''
    },
    // Test order path: skips PayPal entirely by calling create + capture
    // directly. The backend recognizes the configured test email and does not
    // contact PayPal, then transmits the order to SAP for inspection.
    async submitTestOrder () {
      this.invoiceLoading = true
      this.callbackMessage = null
      const filteredQuantitiesMap = Object.fromEntries(
        Object.entries(this.quantitiesMap).filter(([key, value]) => value > 0)
      )
      const consents = {
        consentAdvertising: this.consentA ? 'ja' : 'nein',
        consentZIPCode: this.consentB ? 'ja' : 'nein'
      }
      const effectiveDelivery = this.differentDeliveryAddress
        ? this.deliveryAddress
        : { ...this.invoiceAddress, addressType: AddressType.ADDRESS_TYPE_DELIVERY }
      if (!await this.createMiniShopOrder(this.getUserInput({
        quantitiesMap: filteredQuantitiesMap,
        invoiceAddress: this.invoiceAddress,
        deliveryAddress: effectiveDelivery,
        email: this.email,
        consentsMap: consents,
        gewerbescheinNumber: this.gewerbescheinForSubmit()
      }))) {
        this.invoiceLoading = false
        return
      }
      const createResp = this.$store.state.miniShop.latestRequests.createMiniShopOrder.response
      this.setAndGetCached('vid', createResp.vid)
      this.oid = this.setAndGetCached('oid', createResp.orderId)
      this.setValidationMessages(createResp.messagesMap)
      if (Object.keys(this.validationMessages).length > 0) {
        this.invoiceLoading = false
        return
      }
      this.success = true
      if (await this.captureMiniShopOrder(this.getUserInput({
        orderId: this.oid
      }))) {
        this.captureOrderMessage = this.$store.state.miniShop.latestRequests.captureMiniShopOrder.response.message
        await this.setAndCacheSuccess()
        await this.resetData()
        this.invoiceLoading = false
        this.orderCompleted = true
        this.scrollTop()
      } else {
        this.success = false
        this.invoiceLoading = false
        this.callbackMessage = 'Testbestellung konnte nicht abgeschlossen werden'
      }
    },
    trackMatomoEcommerceOrder (paymentMethod) {
      if (!window._paq || !this.shop || !this.oid) return
      const offers = this.shop.specialOffersList || []
      offers.forEach(o => {
        const qty = this.quantitiesMap[o.id]
        if (!qty) return
        const product = o.product || {}
        window._paq.push([
          'addEcommerceItem',
          String(product.sapId || o.id),
          product.nameDe || '',
          '',
          Number(product.priceB2c) || 0,
          qty
        ])
      })
      const total = Number(this.totalWithVat) || 0
      const net = Number(this.totalWithoutVat) || 0
      const vat = Number(this.vatValue) || 0
      window._paq.push([
        'trackEcommerceOrder',
        String(this.oid),
        total,
        net,
        vat,
        0,
        false
      ])
      window._paq.push(['trackEvent', 'Ecommerce', 'OrderPlaced', paymentMethod || ''])
    },
    async onInvoice () {
      if (this.invoiceLoading) {
        return
      }
      if (window._paq) {
        window._paq.push(['trackEvent', 'Invoice', 'Start'])
      }
      this.invoiceLoading = true
      this.success = true
      this.callbackMessage = null
      this.createOrderError = null
      const filteredQuantitiesMap = Object.fromEntries(
        Object.entries(this.quantitiesMap).filter(([key, value]) => value > 0)
      )
      var consents = {
        consentAdvertising: this.consentA ? 'ja' : 'nein',
        consentZIPCode: this.consentB ? 'ja' : 'nein'
      }
      const effectiveDelivery = this.differentDeliveryAddress
        ? this.deliveryAddress
        : { ...this.invoiceAddress, addressType: AddressType.ADDRESS_TYPE_DELIVERY }
      if (await this.createMiniShopOrder(this.getUserInput({
        quantitiesMap: filteredQuantitiesMap,
        invoiceAddress: this.invoiceAddress,
        deliveryAddress: effectiveDelivery,
        email: this.email,
        consentsMap: consents,
        gewerbescheinNumber: this.gewerbescheinForSubmit()
      }))) {
        this.setAndGetCached('vid', this.$store.state.miniShop.latestRequests.createMiniShopOrder.response.vid)
        this.oid = this.setAndGetCached('oid', this.$store.state.miniShop.latestRequests.createMiniShopOrder.response.orderId)
        this.poid = this.setAndGetCached('poid', this.$store.state.miniShop.latestRequests.createMiniShopOrder.response.paypalOrderId)
        this.setValidationMessages(this.$store.state.miniShop.latestRequests.createMiniShopOrder.response.messagesMap)
        this.createOrderError = (Object.keys(this.validationMessages).length === 0)
        if (window._paq) {
          window._paq.push(['trackEvent', 'Invoice', 'CreateOrder_Success'])
        }
        if (this.poid) {
          if (window._paq) {
            window._paq.push(['trackEvent', 'Invoice', 'Capture_Start'])
          }
          if (await this.captureMiniShopOrder(this.getUserInput({
            orderId: this.oid,
            invoice: true
          }))) {
            if (window._paq) {
              window._paq.push(['trackEvent', 'Invoice', 'Capture_Success'])
            }
            this.trackMatomoEcommerceOrder('invoice')
            this.setAndGetCached('vid', this.$store.state.miniShop.latestRequests.createMiniShopOrder.response.vid)
            this.captureOrderMessage = this.$store.state.miniShop.latestRequests.createMiniShopOrder.response.message
            this.captureOrderError = this.captureOrderMessage === ''
            await this.setAndCacheSuccess()
            await this.resetData()
            this.invoiceLoading = false
            this.orderCompleted = true
            this.scrollTop()
          } else {
            if (window._paq) {
              window._paq.push(['trackEvent', 'Invoice', 'Capture_Failed'])
            }
            this.captureOrderError = true
            this.error({
              error: JSON.stringify({
                error: 'captureOrderError',
                address: this.invoiceAddress
              })
            })
            this.invoiceLoading = false
          }
        }
        this.invoiceLoading = false
      } else {
        this.error({
          error: JSON.stringify({
            error: 'createOrderError',
            address: this.invoiceAddress
          })
        })
        this.createOrderError = true
        this.invoiceLoading = false
      }
    },
    async loadPayPal () {
      if (!this.shop) {
        return
      }
      var app = this
      // eslint-disable-next-line
      paypal.Buttons({
        onInit () {
          if (window._paq) {
            window._paq.push(['trackEvent', 'PayPal', 'Init'])
          }
        },
        onCancel (data) {
          if (window._paq) {
            window._paq.push(['trackEvent', 'PayPal', 'Cancel', JSON.stringify(data)])
          }
          app.callbackMessage = 'Der Vorgang wurde abgebrochen'
          app.scrollTop()
          app.error({
            error: JSON.stringify({
              error: 'Der Vorgang wurde abgebrochen',
              address: app.invoiceAddress
            })
          })
          app.error({ error: 'Der Vorgang wurde abgebrochen' })
        },
        onError (err) {
          if (window._paq) {
            window._paq.push(['trackEvent', 'PayPal', 'Error', (err && err.toString()) || 'Unknown'])
          }
          app.callbackMessage = 'Ein Fehler ist aufgetreten. Der Vorgang wurde abgebrochen'
          app.scrollTop()
          app.error({
            error: JSON.stringify({
              error: err,
              address: app.invoiceAddress
            })
          })
        },
        // Order is created on the server and the order id is returned
        async createOrder () {
          app.callbackMessage = null
          app.createOrderError = null
          if (window._paq) {
            window._paq.push(['trackEvent', 'PayPal', 'CreateOrder_Start'])
          }
          const filteredQuantitiesMap = Object.fromEntries(
            Object.entries(app.quantitiesMap).filter(([key, value]) => value > 0)
          )
          var consents = {
            consentAdvertising: app.consentA ? 'ja' : 'nein',
            consentZIPCode: app.consentB ? 'ja' : 'nein'
          }
          var effectiveDeliveryAddr = app.differentDeliveryAddress
            ? app.deliveryAddress
            : Object.assign({}, app.invoiceAddress, { addressType: AddressType.ADDRESS_TYPE_DELIVERY })
          if (await app.createMiniShopOrder(app.getUserInput({
            quantitiesMap: filteredQuantitiesMap,
            invoiceAddress: app.invoiceAddress,
            deliveryAddress: effectiveDeliveryAddr,
            email: app.email,
            consentsMap: consents,
            gewerbescheinNumber: app.gewerbescheinForSubmit()
          }))) {
            if (window._paq) {
              window._paq.push(['trackEvent', 'PayPal', 'CreateOrder_Success'])
            }
            app.setAndGetCached('vid', app.$store.state.miniShop.latestRequests.createMiniShopOrder.response.vid)
            app.oid = app.setAndGetCached('oid', app.$store.state.miniShop.latestRequests.createMiniShopOrder.response.orderId)
            app.poid = app.setAndGetCached('poid', app.$store.state.miniShop.latestRequests.createMiniShopOrder.response.paypalOrderId)
            app.setValidationMessages(app.$store.state.miniShop.latestRequests.createMiniShopOrder.response.messagesMap)
            app.createOrderError = (Object.keys(app.validationMessages).length === 0)
            return app.poid
          }
          if (window._paq) {
            window._paq.push(['trackEvent', 'PayPal', 'CreateOrder_Failed'])
          }
          app.error({
            error: JSON.stringify({
              error: 'createOrderError',
              address: app.invoiceAddress
            })
          })
          app.createOrderError = true
          return null
        },
        // Finalize the transaction on the server after payer approval
        async onApprove (data) {
          app.captureOrderError = null
          if (window._paq) {
            window._paq.push(['trackEvent', 'PayPal', 'OnApprove_Start', JSON.stringify(data)])
          }
          app.success = true
          if (await app.captureMiniShopOrder(app.getUserInput({
            orderId: app.setAndGetCached('oid', null)
          }))) {
            if (window._paq) {
              window._paq.push(['trackEvent', 'PayPal', 'OnApprove_Capture_Success'])
            }
            app.trackMatomoEcommerceOrder('paypal')
            app.setAndGetCached('vid', app.$store.state.miniShop.latestRequests.createMiniShopOrder.response.vid)
            app.captureOrderMessage = app.$store.state.miniShop.latestRequests.createMiniShopOrder.response.message
            app.captureOrderError = app.captureOrderMessage === ''
            await app.setAndCacheSuccess()
            await app.resetData()
            app.orderCompleted = true
            app.scrollTop()
          } else {
            if (window._paq) {
              window._paq.push(['trackEvent', 'PayPal', 'OnApprove_Capture_Failed'])
            }
            app.captureOrderError = true
            app.error({
              error: JSON.stringify({
                error: 'captureOrderError',
                address: app.invoiceAddress
              })
            })
          }
        }
      }).render('#paypal-button-container')
    },
    async loadMiniShop () {
      // get props, and store them in local storage and get them from local storage
      this.capturedEmail = this.setAndGetCached('ce')
      let urlParams = new URLSearchParams(window.location.search)
      if (await this.getMiniShop({
        shopName: this.$miniShopName,
        vid: this.setAndGetCached('vid', null),
        ref: this.setAndGetCached('ref', urlParams.get('r')),
        fbclid: this.setAndGetCached('fbclid', urlParams.get('fbclid')),
        gclid: this.setAndGetCached('gclid', urlParams.get('gclid')),
        qr: this.setAndGetCached('qr', urlParams.get('q')),
        ua: navigator.userAgent,
        email: this.capturedEmail
      })) {
        this.setAndGetCached('vid', this.$store.state.miniShop.latestRequests.getMiniShop.response.vid)
        this.shop = this.$store.state.miniShop.latestRequests.getMiniShop.response.shop
        this.setRemainingQuantitiesMap(this.$store.state.miniShop.latestRequests.getMiniShop.response.remainingQuantitiesMap)
        this.shop.specialOffersList.forEach(item => {
          let startVal = 0
          if (this.shop.specialOffersList.length === 1 && item.maxQuantityPerCustomer === 1) {
            this.noCartButtons = true
            startVal = 1
          }
          this.quantitiesMap[item.id] = startVal
        })
      }
      this.poid = this.setAndGetCached('poid', null)
    },
    setValidationMessages (messagesMap) {
      let messages = {}
      messagesMap.forEach(item => {
        messages[item[0]] = item[1]
      })
      this.validationMessages = messages
    },
    setRemainingQuantitiesMap (remainingQuantitiesMap) {
      var map = {}
      remainingQuantitiesMap.forEach(item => {
        map[item[0]] = item[1]
        if (this.quantitiesMap[item[0]] > item[1]) {
          this.quantitiesMap[item[0]] = item[1]
        }
      })
      this.remainingQuantitiesMap = map
    },
    setAndGetCached (prop, val) {
      if (val) {
        localStorage.setItem(prop, val)
        return val
      }
      return localStorage.getItem(prop)
    },
    async setAndCacheSuccess () {
      this.success = true
      this.capturedEmail = this.setAndGetCached('ce', this.email)
      localStorage.removeItem('oid')
      localStorage.removeItem('poid')
      this.oid = null
      this.poid = null
    },
    scrollTop () {
      const el = this.$refs.top
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>
